import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Team from './pages/Team';
import AdvisoryServices from './pages/AdvisoryServices';
import InvestmentSolutions from './pages/InvestmentSolutions';
import Contact from './pages/Contact';

import { AuthProvider } from './context/AuthContext';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import ContentEditor, { AdminDashboard } from './pages/admin/ContentEditor';
import TeamManager from './pages/admin/TeamManager';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const PublicShell = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

function App() {
  return (
    <div className="App bg-cream min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="content/:page" element={<ContentEditor />} />
              <Route path="team" element={<TeamManager />} />
            </Route>

            {/* Public */}
            <Route path="/" element={<PublicShell><Home /></PublicShell>} />
            <Route path="/team" element={<PublicShell><Team /></PublicShell>} />
            <Route path="/advisory-services" element={<PublicShell><AdvisoryServices /></PublicShell>} />
            <Route path="/investment-solutions" element={<PublicShell><InvestmentSolutions /></PublicShell>} />
            <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
            {/* Legacy redirects */}
            <Route path="/who-we-are" element={<Navigate to="/team" replace />} />
            <Route path="/who-we-serve" element={<Navigate to="/advisory-services" replace />} />
            <Route path="/who-we-serve/investments" element={<Navigate to="/investment-solutions" replace />} />
            <Route path="/who-we-serve/:section" element={<Navigate to="/advisory-services" replace />} />
            <Route path="/how-we-think" element={<Navigate to="/advisory-services" replace />} />
            <Route path="/how-we-think/:slug" element={<Navigate to="/advisory-services" replace />} />
            <Route path="/what-we-do" element={<Navigate to="/advisory-services" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
